/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_026: Question = {
  id: 'pres-026-taille-complexes-humides',
  oldId: '40',
  title: 'Taille moyenne des complexes de milieux humides',
  number: '3.10',
  description: [''],
  type: QuestionType.INDICATOR,
  frequency: 3,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.HECTARE,
    },
  ],
};

export const question_pres_026_v2: Question = question_pres_026;
export const question_pres_026_v3: Question = question_pres_026;
